import React from "react"
import linkedInSVG from "../../images/linkedin-icon.svg"
import emailSVG from "../../images/email-icon.svg"
import Icons from "./Icons"



export default class IconContainer extends React.Component {
	render(){
		return(<div css={{position:`absolute`,
							top:`5%`,
							left:`65%`,
							width:`100px`,
							height:`auto`,
							display:`flex`,
							justifyContent:`space-evenly`,
							zIndex:`10000`,
							'@media(min-width:600px)':{
								left:'80%'
							},

							'@media(min-width:700px)':{
								left:'85%'
							},

							'@media(min-width:1000px)':{
								left:'90%'
							}
							
						}}>
			   		
			   	
			   		<Icons src={linkedInSVG} width="30" height="30"href="https://www.linkedin.com/in/iisha-small-3689931/"/>
			   		<Icons src={emailSVG} width="30" height="30"href="mailto:iishasmall@gmail.com"/>
			   </div>
			 )
	}
}